import { FaroRoutes } from "@grafana/faro-react";
import React from "react";
import { Route } from "react-router-dom";
import "./App.css";

import { ThemeProvider } from "@mui/material/styles";
import CookieConsent from "react-cookie-consent";
import Feedback from "./components/atoms/feedback.jsx";
import Calendar from "./components/pages/calendar.jsx";
import Contact from "./components/pages/contact.jsx";
import Error from "./components/pages/error.jsx";
import Impressum from "./components/pages/impressum.jsx";
import Landing from "./components/pages/landing.jsx";
import lightTheme from "./themes.ts";

export const FeedbackContext = React.createContext({
  isFeedbackOpen: false,
  setIsFeedbackOpen: () => {},
  feedbackMessage: "",
  setFeedbackMessage: () => {},
  feedbackSeverity: "success",
  setFeedbackSeverity: () => {},
});

function App() {
  // STATE
  const [isFeedbackOpen, setIsFeedbackOpen] = React.useState(false);
  const [feedbackMessage, setFeedbackMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("success");

  // RENDER
  return (
    <ThemeProvider theme={lightTheme}>
      <CookieConsent
        location="bottom"
        buttonText="Akzeptieren"
        style={{ background: "#130D17" }}
        buttonStyle={{
          color: "#E3DABB",
          fontSize: "13px",
          background: "#4E6E58",
        }}
        expires={150}
      >
        Diese Website verwendet Cookies um die User Experience zu verbessern.
      </CookieConsent>
      <FeedbackContext.Provider
        value={{
          isFeedbackOpen: isFeedbackOpen,
          setIsFeedbackOpen: setIsFeedbackOpen,
          feedbackMessage: feedbackMessage,
          setFeedbackMessage: setFeedbackMessage,
          feedbackSeverity: severity,
          setFeedbackSeverity: setSeverity,
        }}
      >
        <Feedback
          open={isFeedbackOpen}
          message={feedbackMessage}
          severity={severity}
          setOpen={setIsFeedbackOpen}
        />
        <FaroRoutes>
          <Route path="/" element={<Landing />} />
          <Route path="/calendar" element={<Calendar />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="*" element={<Error />} />
        </FaroRoutes>
      </FeedbackContext.Provider>
    </ThemeProvider>
  );
}

export default App;
